// extracted by css-extract-rspack-plugin
export default {"row":"row-I4U9kC","main":"main-PWDfel","aside":"aside-ffMKWZ","option":"option-bA9Xpk","optionFields":"optionFields-uJm1ro","optionRemove":"optionRemove-TcdcSn"};